import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgAiSummaryGradient = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_986_21625",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 8,
			y: 6,
			width: 18,
			height: 18,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12.4388 13.0522H17.4239M12.4388 16.3855H17.4239M12.4388 19.7189H17.4239M20.7051 17.3323V21.3855C20.7051 21.8276 20.5295 22.2515 20.2169 22.5641C19.9044 22.8766 19.4805 23.0522 19.0384 23.0522H10.7174C10.2754 23.0522 9.8515 22.8766 9.53894 22.5641C9.22638 22.2515 9.05078 21.8276 9.05078 21.3855V11.3855C9.05078 10.9435 9.22638 10.5196 9.53894 10.207C9.8515 9.89447 10.2754 9.71887 10.7174 9.71887H14.9587M22.7415 14.7188H24.7415M23.7415 13.7188V15.7188M20.7415 7.71875C20.7415 8.24918 20.9522 8.75789 21.3273 9.13296C21.7024 9.50804 22.2111 9.71875 22.7415 9.71875C22.2111 9.71875 21.7024 9.92946 21.3273 10.3045C20.9522 10.6796 20.7415 11.1883 20.7415 11.7188C20.7415 11.1883 20.5308 10.6796 20.1557 10.3045C19.7807 9.92946 19.272 9.71875 18.7415 9.71875C19.272 9.71875 19.7807 9.50804 20.1557 9.13296C20.5308 8.75789 20.7415 8.24918 20.7415 7.71875Z",
				stroke: "black",
				strokeWidth: 1.75,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_986_21625)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 6,
				y: 6,
				width: 20,
				height: 20,
				fill: "url(#paint0_linear_986_21625)"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_986_21625",
			x1: 14.1868,
			y1: -12.8637,
			x2: 38.6226,
			y2: -5.35489,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#8609FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0059E1"
			})]
		}) })
	]
});
export default SvgAiSummaryGradient;
